import { css, styled, Typography } from "@mui/material";

const PREFIX = "jg-home-image-gallery";
export const classes = {
  root: PREFIX,
};

/**
 * Classes used by ReactImageGallery, listed in order of use, from outermost to innermost.
 * HomeImageGallery wraps these classes and HomeImageGalleryItem is wrapped by these classes.
 */
const VENDOR_PREFIX = "image-gallery";
export const vendorClasses = {
  root: VENDOR_PREFIX,
  content: `${VENDOR_PREFIX}-content`,
  slideWrapper: `${VENDOR_PREFIX}-slide-wrapper`,
  swipe: `${VENDOR_PREFIX}-swipe`,
  slides: `${VENDOR_PREFIX}-slides`,
  slide: `${VENDOR_PREFIX}-slide`,
};

export const Container = styled("div")(({ theme }) => {
  const borderRadius = theme.shape.borderRadii[4];
  const borderWidth = theme.shape.borderWidthElevation;

  return css`
    // Passes down to HomeImagerGalleryItem to calc height.
    --jg-home-image-gallery-border-radius: ${borderRadius}px;

    position: relative;
    border-bottom-left-radius: ${borderRadius}px;
    border-bottom-right-radius: ${borderRadius}px;
    box-shadow: 0 0 0 ${borderWidth * 2}px ${theme.palette.background.paper};

    & .${vendorClasses.root} {
      min-height: var(--jg-toolbar-height);
      border-bottom-left-radius: ${borderRadius}px;
      border-bottom-right-radius: ${borderRadius}px;
      box-shadow: 0 0 0 ${borderWidth}px ${theme.palette.background.light};
      overflow: hidden;
    }

    & .${vendorClasses.slides} {
      height: calc(100vh - var(--jg-player-height) + var(--jg-home-image-gallery-border-radius));
    }

    & .${vendorClasses.slide} {
      opacity: 0;;

      /**
       * ReactImageGallery uses the style attribute to attempt to slide the image out
       * like a card, so we must use the !important flag to override this behavior.
       */
      transition: opacity 1000ms ease-out !important;
      transform: none !important;

      &.center {
        opacity: 1;
      }
    }
  `;
});

export const PlayPrompt = styled(Typography)(({ theme }) => css`
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(var(--jg-home-image-gallery-border-radius) + 20px);
  font-size: ${theme.typography.pxToRem(16)};
  text-align: center;
  text-shadow: ${theme.textShadows[3]};
  color: ${theme.palette.common.white};

  ${theme.breakpoints.up("md")} {
    font-size: ${theme.typography.pxToRem(18)};
  }

  ${theme.breakpoints.up("lg")} {
    bottom: calc(var(--jg-home-image-gallery-border-radius) + 40px);
  }
`) as typeof Typography;
